import * as React from "react";
import styled from "styled-components";
import { NavStructurePropTypes } from "../../vars";
import { NavbarDropdownsList } from "./NavbarDropdownsList";

class Navbar extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
  };

  render() {
    const { navStructure, className } = this.props;

    return (
      <div className={className} aria-label="Main Menu" role="menubar">
        <NavbarDropdownsList navStructure={navStructure} />
      </div>
    );
  }
}

export default styled(Navbar)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
